// src/store.ts
import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../models/counterSlice';
import authReducer  from '../models/authSlice'
import currentUserReducer from '../models/currentUserSlice'
import couponsReducer from '../models/couponSlice'
import mycouponsReducer from '../models/myCouponSlice';
import transactionReducer from '../models/transactionSlice';
import sigleCouponReducer from '../models/sigleCouponSlice';
import logoutReducer from '../models/logoutSlice';
import purchaseReducer from '../models/purchaseSlice';
import earnPointsReducer from '../models/earnPointsSlice';

const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    currentUser:currentUserReducer,
    coupon:couponsReducer,
    myCoupons:mycouponsReducer,
    tranaction:transactionReducer,
    singleCoupon:sigleCouponReducer,
    userLogout:logoutReducer,
    purchase:purchaseReducer,
    earnPoints: earnPointsReducer, 
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
